export const PERISCOPE_TAB_TYPES = {
	ACTIONS: 'Actions',
	ACTIVITY: 'Activity',
	APEX_CLASSES: 'APEX Classes',
	APEX_TRIGGERS: 'APEX Triggers',
	AUTOMATION: 'Automation',
	BULK_TAG: 'Bulk Tag',
	BY_COMPONENT_TYPE: 'By Component Type',
	BY_FIELD: 'By Field',
	BY_NODE: 'By Node',
	CODE: 'Code',
	COMPLETION_ACTIONS: 'Completion Actions',
	COMPLETION_ACTION_REFERENCES: 'Completion Action References',
	DETAILS: 'Details',
	EMAIL_ALERTS: 'Email Alerts',
	EMAIL_TEMPLATES: 'Email Templates',
	FIELDS: 'Fields',
	FIELD_METADATA: 'Field Metadata',
	FIELD_UPDATES: 'Field Updates',
	FLOWS: 'Flows',
	FORMULA_FIELDS: 'Formula Fields',
	LANDING_PAGES: 'Landing Pages',
	LIMITS: 'Limits',
	METADATA: 'Metadata',
	PAGE_LAYOUTS: 'Page Layouts',
	PARDOT_EMAILS: 'Emails',
	PARDOT_EMAIL_TEMPLATES: 'Email Templates',
	PARDOT_FIELDS: 'Pardot Fields',
	PARDOT_FORMS: 'Forms',
	PICKLIST_VALUES: 'Picklist Values',
	PROCESS_AUTOMATION: 'Process Automation',
	PROCESS_BUILDERS: 'Process Builders',
	PROFILES: 'Profiles',
	REFERENCES: 'References',
	RELATED_OBJECTS: 'Related Objects',
	RELATED_TECH: 'Related Tech',
	REPORTS: 'Reports',
	RULES: 'Rules',
	RULE_REFERENCES: 'Rule References',
	SALESFORCE_FIELDS: 'SFDC Fields',
	SUPPRESSED_LISTS: 'Suppressed Lists',
	TAGS: 'Tags',
	TO_LISTS: 'To Lists',
	VALIDATION_RULES: 'Validation Rules',
	WORKFLOW_RULES: 'Workflow Rules'
};
